<template>
  <div class="kemudahan-asas">
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.message }}
    </v-snackbar>

    <PageHeader
      :icon="amenity.icon"
      :title="amenity.title"
      :subtitle="amenity.subtitle"
    />

    <!-- Filters + charts -->
    <v-card outlined class="mb-4">
      <!-- Filters -->
      <!-- Setiap penapis memakai susunan yang SAMA: label eyebrow di atas,
           kawalan di bawah. Sebelum ini Negeri memakai label terapung v-select
           manakala Pusingan/Data memakai kapsyen di sebelah kiri — tiga kawalan,
           tiga cara melabel. `align="end"` menjajarkan semua kawalan pada garis
           dasar yang sama walaupun tinggi labelnya berbeza. -->
      <v-card-text class="filter-bar py-3">
        <v-row align="end" dense>
          <v-col cols="12" sm="3">
            <div class="fld__label">Negeri</div>
            <v-select
              v-model="negeri"
              :items="negeriList"
              :disabled="negeriLocked"
              outlined dense hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="auto">
            <div class="fld__label">Pusingan</div>
            <div class="d-flex align-center pusingan-range">
              <v-select v-model="roundRange" :items="roundRangeItems" outlined dense hide-details class="pusingan-sel"></v-select>
            </div>
          </v-col>
          <!-- Data weighting toggle — UI only for now; wire to backend later -->
          <v-col cols="12" sm="auto">
            <div class="fld__label">Data</div>
            <!-- `color="primary"` digugurkan: primary Vuetify = biru, yang
                 bertentangan dengan sistem teal. Keadaan aktif diwarnakan
                 melalui CSS (.data-toggle) sebaliknya. -->
            <!-- 38, bukan 40: + birai 1px atas/bawah = tepat 40px, sama tinggi
                 dengan medan outlined di sebelahnya, supaya label "DATA" duduk
                 pada garis yang sama dengan "NEGERI"/"PUSINGAN". -->
            <v-btn-toggle v-model="dataWajaran" mandatory class="data-toggle">
              <v-btn value="W" height="38" class="text-none px-4">Wajaran</v-btn>
              <v-btn value="TW" height="38" class="text-none px-4">Tanpa Wajaran</v-btn>
            </v-btn-toggle>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="auto">
            <v-btn outlined height="40" class="text-none reset-btn" @click="resetFilters">
              <v-icon small left>mdi-refresh</v-icon>
              Tetapkan Semula
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text class="d-flex align-center flex-wrap py-2">
        <v-spacer></v-spacer>
        <span class="penapis-ringkas text--secondary">{{ filterSummary }}</span>
      </v-card-text>

      <!-- Empty state -->
      <div v-if="loading" class="empty-state text-center py-12 px-4">
        <v-progress-circular indeterminate color="primary" size="48" width="4"></v-progress-circular>
        <div class="subtitle-1 font-weight-medium grey--text text--darken-1 mt-3">Memuatkan data…</div>
      </div>
      <div v-else-if="!hasData" class="empty-state text-center py-12 px-4">
        <v-icon size="56" color="grey lighten-1">mdi-database-off-outline</v-icon>
        <div class="subtitle-1 font-weight-medium grey--text text--darken-1 mt-3">Tiada rekod dijumpai</div>
        <div class="penapis-ringkas grey--text mt-1">Tiada data bagi penapis semasa ({{ filterSummary }}). Sila ubah pilihan penapis.</div>
      </div>

      <!-- Charts: yearly trend (scope total) + composition per negeri/daerah -->
      <v-card-text v-else class="pt-0 pb-2">
        <v-row>
          <!-- <v-col cols="12">
            <v-card outlined>
              <v-card-title class="py-2 subtitle-2">
                <v-icon small class="mr-2">mdi-chart-line</v-icon>
                Trend Mengikut Tahun
                <v-spacer></v-spacer>
                <span class="caption grey--text">{{ scopeName }}</span>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon class="ml-2 dl-btn" title="Muat turun graf" v-bind="attrs" v-on="on">
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item @click="downloadChart('trend', 'png')"><v-list-item-title>PNG</v-list-item-title></v-list-item>
                    <v-list-item @click="downloadChart('trend', 'jpg')"><v-list-item-title>JPG</v-list-item-title></v-list-item>
                  </v-list>
                </v-menu>
              </v-card-title>
              <v-card-text class="trend-chart-box">
                <canvas ref="trendChart"></canvas>
              </v-card-text>
            </v-card>
          </v-col> -->
          <v-col cols="12">
            <v-card outlined>
              <v-card-title class="py-2 subtitle-2">
                <v-icon small class="mr-2">mdi-chart-gantt</v-icon>
                Kategori Mengikut {{ listLabel }}
                <v-spacer></v-spacer>
                <!-- "Semua" ("" = falsy) is the full stack; picking a kategori isolates it -->
                <v-btn-toggle v-model="sortKategori" mandatory dense class="mr-2 sort-toggle" title="Kategori">
                  <v-btn value="" class="text-none px-2">Semua</v-btn>
                  <v-btn v-for="s in subCategories" :key="'kt' + s" :value="s" class="text-none px-2">
                    {{ s }}
                  </v-btn>
                </v-btn-toggle>
                <v-btn-toggle v-model="sortBy" mandatory dense class="mr-2 sort-toggle" title="Susunan">
                  <v-btn value="kod" class="text-none px-2">
                    <v-icon small class="mr-1">mdi-sort-numeric-ascending</v-icon>Kod {{ listLabel === "Negeri" ? "Negeri" : "Daerah" }}/Strata/Kaum
                  </v-btn>
                  <!-- Peratus only makes sense against a chosen kategori; clicking it
                       again while active flips the direction (menurun ⇄ menaik) -->
                  <v-btn
                    v-if="sortKategori"
                    value="pct" class="text-none px-2"
                    :title="pctDesc ? 'Menurun — klik untuk menaik' : 'Menaik — klik untuk menurun'"
                    @mousedown="notePctState" @click="togglePctDir"
                  >
                    <v-icon small class="mr-1">{{ pctDesc ? 'mdi-sort-descending' : 'mdi-sort-ascending' }}</v-icon>Peratus
                  </v-btn>
                </v-btn-toggle>
                <!-- `color="primary"` digugurkan: primary Vuetify = biru. Tahun
                     aktif diwarnakan teal melalui CSS (.year-toggle). -->
                <v-btn-toggle v-model="chartYearModel" mandatory dense class="year-toggle">
                  <v-btn v-for="y in years" :key="'cy' + y" :value="y" class="text-none px-3">{{ y }}</v-btn>
                </v-btn-toggle>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon class="ml-2 dl-btn" title="Muat turun graf" v-bind="attrs" v-on="on">
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item @click="downloadChart('comp', 'png')"><v-list-item-title>PNG</v-list-item-title></v-list-item>
                    <v-list-item @click="downloadChart('comp', 'jpg')"><v-list-item-title>JPG</v-list-item-title></v-list-item>
                  </v-list>
                </v-menu>
              </v-card-title>
              <v-card-text class="pt-1" :style="{ position: 'relative', height: compChartHeight + 'px' }">
                <canvas ref="compChart"></canvas>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="strataRows.length || kaumRows.length" align="stretch">
          <v-col v-if="strataRows.length" cols="12" md="6" class="d-flex">
            <v-card outlined class="flex-grow-1 d-flex flex-column">
              <v-card-title class="py-2 subtitle-2">
                <v-icon small class="mr-2">mdi-city-variant-outline</v-icon>
                Kategori Mengikut Strata
                <v-spacer></v-spacer>
                <span class="caption grey--text">{{ chartYearEff }}</span>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon class="ml-2 dl-btn" title="Muat turun graf" v-bind="attrs" v-on="on">
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item @click="downloadChart('strata', 'png')"><v-list-item-title>PNG</v-list-item-title></v-list-item>
                    <v-list-item @click="downloadChart('strata', 'jpg')"><v-list-item-title>JPG</v-list-item-title></v-list-item>
                  </v-list>
                </v-menu>
              </v-card-title>
              <v-card-text class="pt-1 flex-grow-1" :style="{ position: 'relative', minHeight: strataChartHeight + 'px' }">
                <canvas ref="strataChart"></canvas>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="kaumRows.length" cols="12" md="6" class="d-flex">
            <v-card outlined class="flex-grow-1 d-flex flex-column">
              <v-card-title class="py-2 subtitle-2">
                <v-icon small class="mr-2">mdi-account-group-outline</v-icon>
                Kategori Mengikut Kaum
                <v-spacer></v-spacer>
                <span class="caption grey--text">{{ chartYearEff }}</span>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon class="ml-2 dl-btn" title="Muat turun graf" v-bind="attrs" v-on="on">
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item @click="downloadChart('kaum', 'png')"><v-list-item-title>PNG</v-list-item-title></v-list-item>
                    <v-list-item @click="downloadChart('kaum', 'jpg')"><v-list-item-title>JPG</v-list-item-title></v-list-item>
                  </v-list>
                </v-menu>
              </v-card-title>
              <v-card-text class="pt-1 flex-grow-1" :style="{ position: 'relative', minHeight: kaumChartHeight + 'px' }">
                <canvas ref="kaumChart"></canvas>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

    </v-card>

    <!-- Detailed table -->
    <v-card v-if="!loading && hasData" outlined class="mb-4">
      <v-card-title class="py-3 d-flex align-center flex-wrap">
        <v-icon small class="mr-2">mdi-table</v-icon>
        <span class="subtitle-1 font-weight-medium">{{ amenity.cardTitle }}</span>
        <v-chip x-small color="grey lighten-3" class="ml-3 font-weight-medium">{{ scopeName }}</v-chip>
        <v-spacer></v-spacer>
        <v-btn color="green darken-2" dark class="mr-2 text-none" :loading="exporting" @click="exportExcel">
          <v-icon left>mdi-microsoft-excel</v-icon>
          Excel
        </v-btn>
        <v-btn color="red darken-1" dark class="text-none" :loading="exportingPdf" @click="exportPDF">
          <v-icon left>mdi-file-pdf-box</v-icon>
          PDF
        </v-btn>
      </v-card-title>

      <v-simple-table class="ks-table">
        <thead>
          <!-- Row 1: Kategori + per-year banners + CAGR banner (config: showCagr) -->
          <tr>
            <th class="cat" :rowspan="showCagr ? 3 : 2">Kategori</th>
            <th v-for="y in YEARS" :key="'y' + y" :colspan="subCount" :rowspan="showCagr ? 2 : 1">{{ y }}</th>
            <th v-if="showCagr" :colspan="cagrColCount">Kadar Pertumbuhan Tahunan Dikompaun (CAGR) (%)</th>
          </tr>
          <!-- Row 2 (CAGR shown only): year-pair sub-banners (each spans its N sub-categories) -->
          <tr v-if="showCagr">
            <template v-if="hasCagr">
              <th v-for="p in cagrPairs" :key="'cp' + p.from + p.to" :colspan="subCount" class="cagr-sub">{{ p.from }} - {{ p.to }}</th>
            </template>
            <th v-else :colspan="subCount" class="cagr-sub">—</th>
          </tr>
          <!-- Row 3: sub-category labels under each year AND each CAGR pair -->
          <tr>
            <th v-for="col in subHeaderCells" :key="col.key" class="strata-sub">{{ col.label }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(r, i) in visibleRows">
            <tr v-if="r._isGroup" :key="'g' + i" class="section">
              <td class="cat" :colspan="colCount">{{ r.kategori }}</td>
            </tr>
            <tr v-else-if="r._isSpacer" :key="'sp' + i" class="spacer">
              <td :colspan="colCount"></td>
            </tr>
            <tr
              v-else
              :key="'r' + i + '-' + (r.ng || r.kategori)"
              :class="{ total: r._isTotal, sub: r._isSub }"
            >
              <td class="cat" :class="{ indent: r.indent }">{{ r.kategori }}</td>
              <td
                v-for="col in dataCells(r)"
                :key="col.key"
                :class="{ 'cagr-empty': col.empty }"
              >{{ col.text }}</td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>

      <div class="foot penapis-ringkas text--secondary px-4 py-3 d-flex justify-space-between flex-wrap">
        <span>{{ scopeName }}</span>
        <span>{{ filterSummary }}</span>
      </div>
    </v-card>
  </div>
</template>

<script>
import Chart from "chart.js";
import { addJataHeaderExcel, addJataHeaderPdf } from "@/services/exportHeader";
import { T, loadTheme, argb, rgb, dark } from "@/services/theme";
import hiesWatermark from "@/assets/HIES watermark.png";
import KemudahanAsasServices from "@/services/kemudahanAsas";
import { surveyTitle } from "@/services/surveyYear";
import { negeriStore, loadNegeriList } from "@/services/negeriList";
import getPusingan from "@/services/pusingan";
import { negeriLock } from "@/services/negeriScope";

const svc = new KemudahanAsasServices();
const pusinganSvc = new getPusingan();

// ─────────────────────────────────────────────────────────────────────────────
//  SHOW_CAGR — ONE switch for the "Kadar Pertumbuhan Tahunan Dikompaun (CAGR)
//  (%)" columns on ALL 4 Kemudahan Asas pages (on-screen table + Excel + PDF).
//    true  → CAGR columns shown (default)
//    false → CAGR columns hidden everywhere
//  A single page can override it via its amenity config: { ..., showCagr: false }
// ─────────────────────────────────────────────────────────────────────────────
const SHOW_CAGR = false;

// Negeri dropdown labels come from lookupnegeri via the shared negeriList
// service (negeriStore.list — reactive, cached, with offline fallback).

// series palette for the charts — one colour per sub-category, in the app's
// formal navy/teal family (generic: works for any amenity's sub-category count).
//
// Slot 2 was #1B7E91, a desaturated blue-green only ΔE≈21 from slot 1's teal
// (#0EA5A4) and ΔE≈20 from the grey (#64748B) — adjacent bars read as the same
// series. #1D4E89 is a true blue: ΔE≥28 from every other entry, and it also
// widens the deuteranopia gap against slot 1 (13.6 → 18.6).
// Keep every pair ≥ ~25 ΔE when editing this list.
//
// Slot 0 is the configurable chart colour (/config → tema/warna_graf); the rest
// are fixed, since their whole job is to sit far enough away from slot 0 and
// from each other to stay tellable apart.
const CHART_REST = ["#1D4E89", "#E0A800", "#D9534F", "#64748B", "#7E57C2"];
const chartCols = () => [T.graf, ...CHART_REST];

// Chart.js v2 plugin: print the % value on every bar/segment, 0% included.
//  • vertical bars (trend): value above each bar
//  • stacked horizontal bars: value centred inside the segment when it fits;
//    segments too small to hold their label (incl. 0%) are listed after the
//    end of the bar in their segment colour, so no value is ever hidden
const fmtPctLabel = v => (Math.round(v * 10) / 10).toFixed(1) + "%";
const valueLabelPlugin = {
  afterDatasetsDraw(chart) {
    const ctx = chart.ctx;
    ctx.save();
    // px: label nilai dilukis ke canvas — tiada pewarisan CSS. 13px = --fs-xs.
    ctx.font = "600 13px 'Roboto', sans-serif";
    if (chart.config.type !== "horizontalBar") {
      chart.data.datasets.forEach((ds, di) => {
        const meta = chart.getDatasetMeta(di);
        if (meta.hidden) return;
        meta.data.forEach((el, i) => {
          const v = ds.data[i];
          if (v == null || !el || !el._model) return;
          ctx.fillStyle = "#334155";
          ctx.textAlign = "center";
          ctx.textBaseline = "bottom";
          ctx.fillText(fmtPctLabel(v), el._model.x, el._model.y - 3);
        });
      });
    } else {
      (chart.data.labels || []).forEach((_, i) => {
        const overflow = [];
        let endX = null, midY = null;
        chart.data.datasets.forEach((ds, di) => {
          const meta = chart.getDatasetMeta(di);
          if (meta.hidden) return;
          const el = meta.data[i];
          const v = ds.data[i];
          if (v == null || !el || !el._model) return;
          const m = el._model;
          endX = endX == null ? m.x : Math.max(endX, m.x);
          midY = m.y;
          const label = fmtPctLabel(v);
          if (Math.abs(m.x - m.base) >= ctx.measureText(label).width + 10) {
            ctx.fillStyle = "#fff";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(label, (m.x + m.base) / 2, m.y);
          } else {
            overflow.push({ label, color: ds.backgroundColor });
          }
        });
        if (overflow.length && endX != null) {
          ctx.textAlign = "left";
          ctx.textBaseline = "middle";
          let x = endX + 6;
          overflow.forEach(o => {
            ctx.fillStyle = o.color;
            ctx.fillText(o.label, x, midY);
            x += ctx.measureText(o.label).width + 8;
          });
        }
      });
    }
    ctx.restore();
  },
};

// build the CAGR pair list from an ordered array of year numbers
function cagrPairsFrom(years) {
  return years.slice(0, -1).map((from, i) => {
    const to = years[i + 1];
    return { from, to, years: to - from };
  });
}
// Returns null (→ dash) when an endpoint is missing/null so a pair touching an
// empty year shows "—" instead of a bogus 0%.
function cagr(start, end, years) {
  if (start == null || end == null || start <= 0 || end <= 0) return null;
  return (Math.log(end / start) / years) * 100;
}

function colLetter(n) {
  let s = "";
  while (n > 0) { const r = (n - 1) % 26; s = String.fromCharCode(65 + r) + s; n = Math.floor((n - 1) / 26); }
  return s;
}
function loadScript(src) {
  return new Promise((resolve, reject) => {
    if ([...document.scripts].some(s => s.src === src)) return resolve();
    const el = document.createElement("script");
    el.src = src; el.onload = () => resolve(); el.onerror = () => reject(new Error("Gagal memuatkan " + src));
    document.head.appendChild(el);
  });
}
// load an image asset → { dataUrl(PNG base64), width, height }
// alpha (0-1, optional): bake transparency into the pixels — used for watermarks,
// since jsPDF's addImage has no opacity option of its own
function loadImage(url, alpha) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth; canvas.height = img.naturalHeight;
      const c2d = canvas.getContext("2d");
      if (alpha != null) c2d.globalAlpha = alpha;
      c2d.drawImage(img, 0, 0);
      let dataUrl; try { dataUrl = canvas.toDataURL("image/png"); } catch (e) { dataUrl = url; }
      resolve({ dataUrl, width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = reject; img.src = url;
  });
}

export default {
  name: "KemudahanAsasBase",
  props: {
    // Per-amenity config supplied by the thin wrapper page. Shape:
    //   { key, endpoint, icon, title, subtitle, cardTitle, lampiranRef,
    //     subCategories: [ "label", ... ], fileSlug }
    // The whole page — filters, table, Excel/PDF export — is identical across the
    // four Kemudahan Asas amenities; only the sub-category columns and labels differ.
    amenity: { type: Object, required: true },
  },
  data() {
    return {
      svc,
      years: [],
      cagrPairs: [],
      api: {},
      loading: true,   // start loading — page fetches on created()
      snackbar: { show: false, message: "", color: "success", timeout: 3000 },
      // Default to Malaysia (all states) — same as Bulanan Purata. "ALL" = Malaysia
      // view (MALAYSIA total + Strata + every negeri); a negeriID scopes to one state.
      negeri: "ALL",
      negeriLocked: false,    // true for PP/PO/FE → negeri pinned to own kodneg
      sampel: "3",
      dataWajaran: "W",       // "W" (Wajaran) / "TW" (Tanpa Wajaran) — UI only, wire to backend later
      // Active pusingan only — loaded in created() from getAllPusingan() filtered
      // by status == 1 (same rule as the other jadual-awalan pages). Falls back to
      // 1..12 if the service is unavailable.
      roundItems: [],
      // Pusingan range filter (From–To). Defaults to first–last available in
      // loadActiveRounds(). selectedRoundsModel is derived from this range.
      roundFrom: null,
      roundTo: null,
      // year shown in the composition chart; null = latest available (chartYearEff)
      chartYear: null,
      // composition-chart bar order: "kod" (negeri/daerah code, default) |
      // "pct" (selected jenis %, highest first). Chart only — never the table.
      sortBy: "kod",
      // the kategori (sub-category, e.g. Dimiliki/Disewa/Kuarters) shown in the
      // composition chart and ranked by the Peratus sort; null (default) = show
      // ALL kategori stacked → Peratus option hidden
      sortKategori: "",
      // Peratus direction: true = highest first; re-clicking the active button flips it
      pctDesc: true,
      exporting: false,
      exportingPdf: false,
    };
  },
  computed: {
    todayStr() { return new Date().toISOString().slice(0, 10); },
    YEARS() { return this.years; },
    // The amenity's sub-categories (e.g. Dimiliki / Disewa / Kuarters). Falls back to
    // a single "Jumlah" so the table still renders if a config forgets them.
    subCategories() {
      const s = this.amenity && this.amenity.subCategories;
      return Array.isArray(s) && s.length ? s : ["Jumlah"];
    },
    subCount() { return this.subCategories.length; },
    hasCagr() { return this.cagrPairs.length > 0; },
    // CAGR columns visible? (global SHOW_CAGR, overridable per page via amenity.showCagr)
    showCagr() {
      const a = this.amenity;
      return a && a.showCagr != null ? !!a.showCagr : SHOW_CAGR;
    },
    cagrColCount() { return this.showCagr ? Math.max(1, this.cagrPairs.length) * this.subCount : 0; },
    // Flat list of the CAGR data columns (one per pair × sub-category); mirrors the
    // year columns. Each carries a value(row) accessor reading row.cagr[key].
    // Empty when the CAGR columns are switched off — the table body and both
    // exports iterate this list, so hiding here hides everywhere.
    cagrExportCols() {
      if (!this.showCagr) return [];
      const out = [];
      if (this.cagrPairs.length) {
        this.cagrPairs.forEach(p => {
          this.subCategories.forEach(s => out.push({
            pairLabel: `${p.from} - ${p.to}`,
            sub: s,
            value: row => (row.cagr || {})[p.from + "-" + p.to + "|" + s],
          }));
        });
      } else {
        this.subCategories.forEach(s => out.push({ pairLabel: "—", sub: s, value: () => null }));
      }
      return out;
    },
    // Kategori + (N sub cols per year) + CAGR columns (pairs×N, ≥N)
    colCount() { return 1 + this.years.length * this.subCount + this.cagrColCount; },
    subHeaderCells() {
      // headers carry the unit — "Dimiliki (%)" — so the body cells stay plain numbers
      const cells = [];
      this.years.forEach(y => {
        this.subCategories.forEach(s => cells.push({ key: "y" + y + s, label: `${s} (%)` }));
      });
      this.cagrExportCols.forEach((c, i) => cells.push({ key: "c" + i, label: `${c.sub} (%)` }));
      return cells;
    },
    hasData() {
      return this.years.length > 0 && (this.api.rows || []).length > 0;
    },
    // Malaysia (all states) first, then each negeri — mirrors Bulanan Purata.
    negeriList() {
      // Locked roles (PP/PO/FE) only see their own negeri — no Malaysia/other options.
      if (this.negeriLocked) {
        return negeriStore.list.filter(n => n.id === this.negeri).map(n => ({ text: n.nama, value: n.id }));
      }
      return [{ text: "Malaysia", value: "ALL" }, ...negeriStore.list.map(n => ({ text: n.nama, value: n.id }))];
    },
    negeriName() { const m = {}; negeriStore.list.forEach(n => (m[n.id] = n.nama)); return m; },
    selectedRoundsModel() {
      if (this.roundFrom == null || this.roundTo == null) return [];
      const lo = Math.min(this.roundFrom, this.roundTo);
      const hi = Math.max(this.roundFrom, this.roundTo);
      return this.roundItems.filter(p => p >= lo && p <= hi);
    },
    selectedRounds() { return [...this.selectedRoundsModel].sort((a, b) => a - b); },
    allRounds() { return this.roundItems.length > 0 && this.selectedRoundsModel.length === this.roundItems.length; },
    // Pusingan sentiasa julat berlabuh pada pusingan pertama — pengguna hanya
    // memilih hujungnya (01 - 01 … 01 - 12), jadi permulaan 02 mustahil dari binaan.
    roundRangeItems() {
      const pad = n => String(n).padStart(2, "0");
      const lo = this.roundItems.length ? this.roundItems[0] : null;
      return this.roundItems.map(p => ({ text: `${pad(lo)} - ${pad(p)}`, value: p }));
    },
    // One dropdown, so the start can never drift off the first pusingan.
    roundRange: {
      get() { return this.roundTo; },
      set(v) {
        if (this.roundItems.length) this.roundFrom = this.roundItems[0];
        this.roundTo = v;
      },
    },
    ddLabel() {
      if (this.allRounds) return "Semua Pusingan";
      if (!this.selectedRoundsModel.length) return "Tiada dipilih";
      const lo = this.selectedRounds[0];
      const hi = this.selectedRounds[this.selectedRounds.length - 1];
      return lo === hi ? `Pusingan ${lo}` : `Pusingan ${lo}–${hi}`;
    },
    // Wajaran / Tanpa Wajaran label for the summary + exports.
    wajaranLabel() { return this.dataWajaran === "TW" ? "Tanpa Wajaran" : "Wajaran"; },
    // Pusingan slug for filenames: always a range — "Pusingan2" or "Pusingan1-12".
    pusinganSlug() {
      const rounds = this.selectedRounds.length ? this.selectedRounds : this.roundItems;
      if (!rounds.length) return "Pusingan";
      const lo = rounds[0];
      const hi = rounds[rounds.length - 1];
      return "Pusingan" + (lo === hi ? `${lo}` : `${lo}-${hi}`);
    },
    exportFileName() {
      const parts = [this.amenity.fileSlug || "Kemudahan_Asas"];
      parts.push((this.scopeName || "").replace(/[^A-Za-z0-9]+/g, ""));   // negeri always set
      parts.push(this.pusinganSlug);
      parts.push(this.dataWajaran === "TW" ? "TanpaWajaran" : "Wajaran");
      parts.push(this.todayStr.replace(/-/g, ""));
      return parts.join("_");
    },
    scopeName() { return this.negeri === "ALL" ? "Malaysia" : (this.negeriName[this.negeri] || this.negeri); },
    // Attach the per-row CAGR map (pair × sub-category) derived from the row's yearly
    // values, keyed "<from>-<to>|<sub>".
    withCagr() {
      const pairs = this.cagrPairs;
      const subs = this.subCategories;
      return row => {
        const cagrMap = {};
        pairs.forEach(p => {
          subs.forEach(s => {
            const vals = (row.values && row.values[s]) || {};
            cagrMap[p.from + "-" + p.to + "|" + s] = cagr(vals[p.from], vals[p.to], p.years);
          });
        });
        return { ...row, cagr: cagrMap };
      };
    },
    // Flat render list built from the API `rows` payload (already scope-ordered by the
    // service, each row tagged with `group`). We inject a group heading on each group
    // transition, plus a grey spacer row between data groups (after Strata, after Kaum
    // — i.e. before Kaum and before the list), matching Bulanan Purata:
    //   Malaysia view : MALAYSIA total → "Strata" ┄ "Kaum" ┄ "Negeri"
    //   Negeri  view  : <negeri> total → "Strata" ┄ "Kaum" ┄ "Daerah Pentadbiran"
    visibleRows() {
      const wc = this.withCagr;
      const rows = Array.isArray(this.api.rows) ? this.api.rows : [];
      if (!rows.length) return [];
      const isAll = this.negeri === "ALL";
      // heading text per group; the "list" group depends on the scope.
      const heading = { strata: "Strata", kaum: "Kaum", list: isAll ? "Negeri" : "Daerah Pentadbiran" };
      const out = [];
      let lastGroup = null;
      rows.forEach(r => {
        const g = r.group || (r.isTotal ? "total" : "list");
        if (g === "total") { out.push({ ...wc(r), _isTotal: true }); lastGroup = g; return; }
        if (g !== lastGroup) {
          // grey spacer closes the previous data group (Strata/Kaum) before the next
          // heading — not after the total, so no line sits directly under the total.
          if (lastGroup && lastGroup !== "total") out.push({ _isSpacer: true });
          out.push({ _isGroup: true, kategori: heading[g] || "" });
          lastGroup = g;
        }
        out.push({ ...wc(r), _isSub: true });
      });
      return out;
    },
    // Exports mirror the on-screen grouping: the scope total sits under the amenity
    // title, then one section per group (Strata → Kaum → Negeri/Daerah Pentadbiran).
    sections() {
      const wc = this.withCagr;
      const rows = Array.isArray(this.api.rows) ? this.api.rows : [];
      if (!rows.length) return [];
      const isAll = this.negeri === "ALL";
      const title = { total: this.amenity.cardTitle, strata: "Strata", kaum: "Kaum", list: isAll ? "Negeri" : "Daerah Pentadbiran" };
      const order = ["total", "strata", "kaum", "list"];
      const byGroup = {};
      rows.forEach(r => {
        const g = r.group || (r.isTotal ? "total" : "list");
        (byGroup[g] = byGroup[g] || []).push(wc(r));
      });
      return order
        .filter(g => byGroup[g] && byGroup[g].length)
        .map(g => ({ key: g, title: title[g], rows: byGroup[g] }));
    },
    filterSummary() {
      const rd = this.allRounds ? "Semua pusingan" : "Pusingan " + this.selectedRounds.join(",");
      return `${this.scopeName} • ${rd} • ${this.wajaranLabel}`;
    },
    /* ---- charts ---- */
    // the scope total row (MALAYSIA / selected negeri) — feeds the trend chart
    totalRow() {
      const rows = Array.isArray(this.api.rows) ? this.api.rows : [];
      return rows.find(r => (r.group || (r.isTotal ? "total" : "list")) === "total") || null;
    },
    // the "list" group rows (negeri in the Malaysia view, daerah when scoped) —
    // feeds the composition chart, one stacked bar each
    listRows() {
      const rows = Array.isArray(this.api.rows) ? this.api.rows : [];
      return rows.filter(r => (r.group || (r.isTotal ? "total" : "list")) === "list");
    },
    listLabel() { return this.negeri === "ALL" ? "Negeri" : "Daerah Pentadbiran"; },
    // composition-chart order per the Susunan toggle. "kod" keeps the API order
    // (already by negeri/daerah code); "pct" ranks by the SELECTED kategori's %
    // (e.g. Dimiliki) at the shown year — only available once a kategori is chosen.
    // The same ordering is applied to the strata + kaum charts (see sortByPct).
    chartListRows() {
      return this.sortByPct(this.listRows);
    },
    // strata / kaum group rows for the current scope — one stacked bar each
    strataRows() {
      const rows = Array.isArray(this.api.rows) ? this.api.rows : [];
      return rows.filter(r => (r.group || "") === "strata");
    },
    kaumRows() {
      const rows = Array.isArray(this.api.rows) ? this.api.rows : [];
      return rows.filter(r => (r.group || "") === "kaum");
    },
    // effective chart year: the toggle's pick if still valid, else the latest year
    chartYearEff() {
      if (this.chartYear && this.years.includes(this.chartYear)) return this.chartYear;
      return this.years.length ? this.years[this.years.length - 1] : null;
    },
    // v-btn-toggle binding: shows the effective year as active, writes chartYear
    chartYearModel: {
      get() { return this.chartYearEff; },
      set(v) { this.chartYear = v; },
    },
    // composition charts grow with the number of bars so labels never cramp
    // 40px setiap kategori, bukan 28: carta ini BERTINDAN (beberapa sub-kategori
    // sebaris), jadi tinggi slot itulah yang menentukan ketebalan bar tunggal
    // pada setiap baris. `maxBarThickness: 28` di atas hanyalah had atas.
    compChartHeight() {
      return Math.max(240, this.listRows.length * 40 + 84);
    },
    strataChartHeight() {
      return Math.max(150, this.strataRows.length * 38 + 84);
    },
    kaumChartHeight() {
      return Math.max(150, this.kaumRows.length * 38 + 84);
    },
  },
  watch: {
    negeri() { this.queueFetch(); },
    sampel() { this.queueFetch(); },
    dataWajaran() { this.queueFetch(); },
    roundFrom(v) { if (v != null && this.roundTo != null && this.roundTo < v) this.roundTo = v; },
    selectedRoundsModel() { this.queueFetch(); },
    // new data → redraw both charts once the canvases are (re)rendered
    api() { this.$nextTick(this.drawCharts); },
    chartYear() { this.$nextTick(this.drawCompositionCharts); },
    // Susunan toggle re-orders ALL three composition charts (negeri/daerah,
    // strata, kaum) together, so they stay consistent.
    sortBy() { this.$nextTick(this.drawCompositionCharts); },
    pctDesc() { if (this.sortBy === "pct") this.$nextTick(this.drawCompositionCharts); },
    // kategori picked/changed/cleared → redraw ALL composition charts showing only
    // it, or the full stack when cleared. A clear while sorted by Peratus first
    // falls back to kod order (the sortBy watcher then redraws).
    sortKategori(v) {
      if (!v && this.sortBy === "pct") this.sortBy = "kod";
      this.$nextTick(this.drawCompositionCharts);
    },
  },
  async created() {
    loadNegeriList(); // refresh negeri names from lookupnegeri (shared cache)
    // Restricted roles (PP/PO/FE) are pinned to their own negeri — lock the selector
    // and default it to their kodneg before the first fetch. (The backend enforces
    // this too, so the data is scoped regardless; this is the matching UI.)
    const lock = negeriLock(this.$store);
    if (lock.locked) {
      this.negeri = lock.kodneg;
      this.negeriLocked = true;
    }
    // load the active-pusingan filter first (status == 1), then fetch the table.
    // queueFetch (not fetchData) — selectFullRange inside loadActiveRounds already
    // queued a fetch via the selectedRoundsModel watcher; queueing again coalesces
    // both into ONE request, so the charts don't build + animate twice on load.
    await this.loadActiveRounds();
    this.queueFetch();
  },
  beforeDestroy() {
    if (this._trendChart) this._trendChart.destroy();
    if (this._compChart) this._compChart.destroy();
    if (this._strataChart) this._strataChart.destroy();
    if (this._kaumChart) this._kaumChart.destroy();
    clearTimeout(this._fetchTimer);
  },
  methods: {
    queueFetch() { clearTimeout(this._fetchTimer); this._fetchTimer = setTimeout(() => this.fetchData(), 0); },
    async fetchData() {
      this.loading = true;
      try {
        // empty pusingan selection = explicit "none" (marker), not "all".
        const P = this.selectedRoundsModel.length === 0 ? "__NONE__" : this.selectedRounds.join(",");
        const params = { P, S: this.sampel, W: this.dataWajaran };
        if (this.negeri !== "ALL") params.NG = this.negeri;   // absent NG = Malaysia
        const d = await this.svc.getKemudahanAsas(this.amenity.endpoint, params);
        this.years = (d.years || []).map(Number);
        this.cagrPairs = cagrPairsFrom(this.years);
        this.api = d;
      } catch (err) {
        // No backend yet → empty state. Wire the controller later; UI is ready.
        this.api = {}; this.years = []; this.cagrPairs = [];
      }
      this.loading = false;
    },
    // Amenity figures are PERCENTAGES of households (%), not RM.
    // body cells are plain numbers — the (%) unit lives in the column headers
    pct(n) {
      if (n === null || n === undefined) return "—";
      return Number(n).toFixed(1);
    },
    pf(n) {
      if (n === null || n === undefined) return "—";
      return n.toFixed(1);
    },
    dataCells(r) {
      const cells = [];
      const vals = r.values || {};
      this.years.forEach(y => {
        this.subCategories.forEach(s => {
          const cell = (vals[s] || {})[y];
          cells.push({ key: "v" + y + s, text: this.pct(cell) });
        });
      });
      this.cagrExportCols.forEach((c, i) => {
        const v = c.value(r);
        const empty = v === null || v === undefined;
        cells.push({ key: "c" + i, text: empty ? "—" : this.pf(v), empty });
      });
      return cells;
    },
    /* ---- charts ---- */
    // Peratus direction flip: only when the button was ALREADY active when the
    // click began. mousedown fires before Vuetify's toggle updates sortBy, so the
    // snapshot distinguishes "activate Peratus" from "flip its direction".
    notePctState() {
      this._pctWasActive = this.sortBy === "pct";
    },
    togglePctDir() {
      if (this._pctWasActive) this.pctDesc = !this.pctDesc;
    },
    drawCharts() {
      this.drawTrendChart();
      this.drawCompositionCharts();
    },
    // Trend: grouped columns of the scope total's % per sub-category across years —
    // the visual anchor for the table's CAGR columns
    drawTrendChart() {
      if (this._trendChart) { this._trendChart.destroy(); this._trendChart = null; }
      const ctx = this.$refs.trendChart;
      if (!ctx || !this.hasData || !this.totalRow) return;
      const vals = this.totalRow.values || {};
      const datasets = this.subCategories.map((s, i) => ({
        label: s,
        data: this.years.map(y => {
          const v = (vals[s] || {})[y];
          return v == null ? null : Math.round(v * 10) / 10;
        }),
        backgroundColor: chartCols()[i % (CHART_REST.length + 1)],
        borderWidth: 0,
        // no fixed thickness cap — bars take a proportional share of the
        // category width, so they grow/shrink with the screen resolution
        // 0.8/0.9 (dahulu 0.62/0.85): bar mengambil bahagian yang lebih besar
        // daripada slot tahunnya. Jurang antara kumpulan tahun mengecil, tetapi
        // masih ada — 1.0 akan merapatkan bar antara tahun tanpa celah.
        categoryPercentage: 0.8,
        barPercentage: 0.9,
      }));
      this._trendChart = new Chart(ctx, {
        type: "bar",
        data: { labels: this.years.map(String), datasets },
        plugins: [valueLabelPlugin],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          animation: { duration: 900, easing: "easeOutQuart" },
          layout: { padding: { top: 18 } },
          legend: { position: "bottom", labels: { boxWidth: 14, fontSize: 13 } },
          tooltips: {
            callbacks: {
              label: (t, d) => {
                const ds = d.datasets[t.datasetIndex];
                const v = ds.data[t.index];
                return ` ${ds.label}: ${v == null ? "—" : v.toFixed(1) + "%"}`;
              },
            },
          },
          scales: {
            xAxes: [{ gridLines: { display: false } }],
            yAxes: [{ ticks: { beginAtZero: true, callback: v => v + "%" }, gridLines: { color: "#EEF2F6" } }],
          },
        },
      });
    },
    // Generic 100% stacked horizontal bar chart: one bar per row, split into the
    // amenity's sub-categories for the given year. Shared by the negeri/daerah,
    // strata and kaum composition charts.
    // Order rows by the SELECTED kategori's % (Peratus sort), or return them
    // unchanged when not sorting by percentage. Shared by ALL composition charts
    // (negeri/daerah, strata, kaum) so the Susunan toggle affects them together.
    sortByPct(rows) {
      if (this.sortBy !== "pct" || !this.sortKategori) return rows;
      const y = this.chartYearEff;
      const s = this.sortKategori;
      const pct = r => {
        const v = ((r.values || {})[s] || {})[y];
        return v == null ? -1 : v;
      };
      return [...rows].sort((a, b) => (this.pctDesc ? pct(b) - pct(a) : pct(a) - pct(b)));
    },
    // subs = optional kategori subset to display (default: all, stacked); each
    // kategori keeps its palette colour even when shown alone
    makeStackedBar(ctx, rows, year, subs) {
      const datasets = (subs || this.subCategories).map(s => ({
        label: s,
        data: rows.map(r => {
          const v = ((r.values || {})[s] || {})[year];
          return v == null ? 0 : Math.round(v * 10) / 10;
        }),
        backgroundColor: chartCols()[Math.max(0, this.subCategories.indexOf(s)) % (CHART_REST.length + 1)],
        borderWidth: 0,
        maxBarThickness: 28,
      }));
      // Sabah/Sarawak: kaum rows carry `indent` for the Bumiputera sub-groups
      // (Melayu, Kadazan/Dusun … Bumiputera lain). Shade the top-level rows so
      // the parent/child split is visible on the chart, not just in the table.
      // No-op for charts whose rows are flat (negeri/daerah, strata).
      const hasSub = rows.some(r => r.indent);
      const groupBandPlugin = {
        // beforeDraw, not beforeDatasetsDraw: the band must go UNDER the axis labels
        beforeDraw(chart) {
          const y = chart.scales["y-axis-0"];
          if (!y || !rows.length) return;
          const h = (y.bottom - y.top) / rows.length;
          const c = chart.ctx;
          c.save();
          c.fillStyle = "#EAF1F5";
          rows.forEach((r, i) => {
            if (!r.indent) c.fillRect(0, y.getPixelForTick(i) - h / 2, chart.width, h);
          });
          c.restore();
        },
      };
      return new Chart(ctx, {
        type: "horizontalBar",
        data: { labels: rows.map(r => (r.indent ? "    " + r.kategori : r.kategori)), datasets },
        plugins: hasSub ? [valueLabelPlugin, groupBandPlugin] : [valueLabelPlugin],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          animation: { duration: 900, easing: "easeOutQuart" },
          // room to the right of the 100% line for the spill-over value labels
          layout: { padding: { right: 88 } },
          legend: { position: "bottom", labels: { boxWidth: 14, fontSize: 13 } },
          tooltips: {
            mode: "nearest",
            callbacks: {
              label: (t, d) => {
                const ds = d.datasets[t.datasetIndex];
                const v = ds.data[t.index];
                return ` ${ds.label}: ${v == null ? "—" : v.toFixed(1) + "%"}`;
              },
            },
          },
          scales: {
            xAxes: [{ stacked: true, ticks: { min: 0, max: 100, callback: v => v + "%" }, gridLines: { color: "#EEF2F6" } }],
            yAxes: [{ stacked: true, gridLines: { display: false }, ticks: { fontSize: 13, autoSkip: false } }],
          },
        },
      });
    },
    drawCompChart() {
      if (this._compChart) { this._compChart.destroy(); this._compChart = null; }
      const ctx = this.$refs.compChart;
      if (!ctx || !this.hasData || !this.chartListRows.length || !this.chartYearEff) return;
      // kategori chosen → show only that kategori's bars; else the full stack
      const subs = this.sortKategori ? [this.sortKategori] : null;
      this._compChart = this.makeStackedBar(ctx, this.chartListRows, this.chartYearEff, subs);
    },
    drawStrataChart() {
      if (this._strataChart) { this._strataChart.destroy(); this._strataChart = null; }
      const ctx = this.$refs.strataChart;
      if (!ctx || !this.hasData || !this.strataRows.length || !this.chartYearEff) return;
      const subs = this.sortKategori ? [this.sortKategori] : null;
      this._strataChart = this.makeStackedBar(ctx, this.sortByPct(this.strataRows), this.chartYearEff, subs);
    },
    drawKaumChart() {
      if (this._kaumChart) { this._kaumChart.destroy(); this._kaumChart = null; }
      const ctx = this.$refs.kaumChart;
      if (!ctx || !this.hasData || !this.kaumRows.length || !this.chartYearEff) return;
      const subs = this.sortKategori ? [this.sortKategori] : null;
      this._kaumChart = this.makeStackedBar(ctx, this.sortByPct(this.kaumRows), this.chartYearEff, subs);
    },
    // the three composition charts share the year toggle
    drawCompositionCharts() {
      this.drawCompChart();
      this.drawStrataChart();
      this.drawKaumChart();
    },
    // download one of the charts as an image — 'png' (transparent background) or
    // 'jpg' (white; JPEG has no alpha channel, unfilled pixels would turn black).
    // A title + filter band is composited on top so the image stands alone in reports.
    downloadChart(key, format) {
      const year = this.chartYearEff;
      const targets = {
        trend: { chart: this._trendChart, title: "Trend Mengikut Tahun", slug: "Trend_Tahun" },
        comp: {
          chart: this._compChart,
          title: `Kategori Mengikut ${this.listLabel} (${year})`,
          slug: (this.listLabel === "Negeri" ? "Kategori_Negeri_" : "Kategori_Daerah_") + year,
        },
        strata: { chart: this._strataChart, title: `Kategori Mengikut Strata (${year})`, slug: "Kategori_Strata_" + year },
        kaum: { chart: this._kaumChart, title: `Kategori Mengikut Kaum (${year})`, slug: "Kategori_Kaum_" + year },
      };
      const t = targets[key];
      if (!t || !t.chart) return;
      const jpg = format === "jpg";
      const src = t.chart.canvas;
      // Chart.js renders at devicePixelRatio — scale the header band to match
      const scale = src.width / (src.clientWidth || src.width);
      const pad = Math.round(56 * scale);
      const out = document.createElement("canvas");
      out.width = src.width;
      out.height = src.height + pad;
      const c = out.getContext("2d");
      if (jpg) {
        c.fillStyle = "#fff";
        c.fillRect(0, 0, out.width, out.height);
      }
      c.fillStyle = "#0B1F3A";
      c.font = `700 ${Math.round(17 * scale)}px Roboto, sans-serif`;
      c.fillText(t.title, Math.round(16 * scale), Math.round(26 * scale));
      c.fillStyle = "#64748B";
      c.font = `400 ${Math.round(13 * scale)}px Roboto, sans-serif`;
      c.fillText(`${this.amenity.cardTitle} • ${this.filterSummary}`, Math.round(16 * scale), Math.round(44 * scale));
      c.drawImage(src, 0, pad);
      const a = document.createElement("a");
      a.href = jpg ? out.toDataURL("image/jpeg", 0.95) : out.toDataURL("image/png");
      a.download = `Graf_${t.slug}_${this.exportFileName}` + (jpg ? ".jpg" : ".png");
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    selectFullRange() {
      if (!this.roundItems.length) return;
      this.roundFrom = this.roundItems[0];
      this.roundTo = this.roundItems[this.roundItems.length - 1];
    },
    resetFilters() {
      // Locked roles (PP/PO/FE) stay pinned to their own negeri — "ALL" is not in
      // their negeriList, so resetting to it would blank the select and mislabel
      // the scope (chip/exports would read "Malaysia").
      if (!this.negeriLocked) this.negeri = "ALL";
      this.sampel = "3";
      this.selectFullRange();
    },
    // Load the active pusingan (status == 1) and default-select them all. Mirrors
    // the other jadual-awalan pages' getAllPusingan() + status filter. Falls back to 1..12.
    async loadActiveRounds() {
      let rounds = Array.from({ length: 12 }, (_, i) => i + 1);
      try {
        const res = await pusinganSvc.getAllPusingan();
        const rows = (res && res.data && res.data.data) || [];
        const active = rows
          .filter(r => r.status == "1" || r.status == 1)
          .map(r => parseInt(r.pusingan, 10))
          .filter(n => !isNaN(n));
        const uniq = [...new Set(active)].sort((a, b) => a - b);
        if (uniq.length) rounds = uniq;
      } catch (e) {
        console.error("loadActiveRounds failed:", e);
      }
      this.roundItems = rounds;
      this.selectFullRange();
    },

    /* ---- styled .xlsx export ---- */
    async exportExcel() {
      this.exporting = true;
      try {
        await loadTheme();
        await loadScript("/js/exceljs.min.js");
        const ExcelJS = window.ExcelJS;
        const NAVY = argb(T.tajukLaporan), HEAD = argb(T.kepalaJadual), NAVY2 = argb(dark(T.kepalaJadual)), TEAL = argb(T.graf), WHITE = "FFFFFFFF",
              GROUP = "FFE8EEF3", SUB = "FFF4F8FA", LINE = "FFE2E8F0";
        const thin = { style: "thin", color: { argb: LINE } };
        const border = { top: thin, left: thin, bottom: thin, right: thin };
        const center = { vertical: "middle", horizontal: "center", wrapText: true };
        const fill = argb => ({ type: "pattern", pattern: "solid", fgColor: { argb } });

        const YEARS = this.years, CAGR_PAIRS = this.cagrPairs;
        const CAGR_COLS = this.cagrExportCols;
        const SUBS = this.subCategories, nSub = this.subCount;
        const dataCols = YEARS.length * nSub + CAGR_COLS.length;
        const nCols = 1 + dataCols, L = colLetter, last = L(nCols);
        const MIN_BANNER_COLS = 6;
        const bannerCols = Math.max(nCols, MIN_BANNER_COLS);
        const bannerLast = L(bannerCols);
        const firstCagrIdx = 2 + YEARS.length * nSub;

        const wb = new ExcelJS.Workbook();
        const ws = wb.addWorksheet(this.amenity.sheetName || "Kemudahan Asas", { views: [{ showGridLines: false }] });
        const colWidths = [{ width: 26 }, ...Array(YEARS.length * nSub).fill({ width: 15 }), ...CAGR_COLS.map(() => ({ width: 14 }))];
        while (colWidths.length < bannerCols) colWidths.push({ width: 12 });
        ws.columns = colWidths;

        // ── Logo row 1: Jata Negara crest + config-driven title (services/exportHeader) ──
        await addJataHeaderExcel(wb, ws, colWidths, bannerLast);

        // ── Title block (rows 2-3, below the logo) ───────────────────────────
        ws.mergeCells(`A2:${bannerLast}2`);
        Object.assign(ws.getCell("A2"), {
          value: await surveyTitle(),
          alignment: center, font: { bold: true, size: 12, color: { argb: WHITE } }, fill: fill(NAVY),
        });
        ws.getRow(2).height = 24;

        ws.mergeCells(`A3:${bannerLast}3`);
        Object.assign(ws.getCell("A3"), {
          value: (this.amenity.exportTitle || this.amenity.cardTitle || "").toUpperCase(),
          alignment: center, font: { bold: true, size: 11, color: { argb: WHITE } }, fill: fill(TEAL),
        });
        ws.getRow(3).height = 20;

        // Filter summary — ONE line spanning the full width (matches the PDF layout).
        ws.mergeCells(`A5:${bannerLast}5`);
        Object.assign(ws.getCell("A5"), {
          value: `Pilihan: ${this.scopeName}     |     Pusingan: ${this.ddLabel}     |     Data: ${this.wajaranLabel}`,
          font: { size: 10 }, alignment: { vertical: "middle", horizontal: "left" },
        });
        ws.getRow(5).height = 18;

        const setH = (cell, text, bg) => Object.assign(ws.getCell(cell), {
          value: text, alignment: center, border,
          font: { bold: true, size: 10, color: { argb: WHITE } }, fill: fill(bg || HEAD),
        });
        // header rows HEAD1 (year/cagr banner), HEAD2 (sub-category) — after the
        // logo row + title block + 1-line summary. Kategori merged across both.
        const HEAD1 = 7, HEAD2 = 8;
        ws.mergeCells(`A${HEAD1}:A${HEAD2}`); setH(`A${HEAD1}`, "KATEGORI");
        YEARS.forEach((y, i) => {
          const c0 = L(2 + i * nSub), c2 = L(2 + i * nSub + nSub - 1);
          ws.mergeCells(`${c0}${HEAD1}:${c2}${HEAD1}`); setH(`${c0}${HEAD1}`, String(y));
          SUBS.forEach((s, si) => setH(`${L(2 + i * nSub + si)}${HEAD2}`, `${s} (%)`, NAVY2));
        });
        const cagrBanners = !this.showCagr ? []
          : CAGR_PAIRS.length
            ? CAGR_PAIRS.map(p => `CAGR ${p.from} - ${p.to} (%)`)
            : ["KADAR PERTUMBUHAN TAHUNAN DIKOMPAUN (CAGR) (%)"];
        cagrBanners.forEach((label, gi) => {
          const c0 = L(firstCagrIdx + gi * nSub), c2 = L(firstCagrIdx + gi * nSub + nSub - 1);
          ws.mergeCells(`${c0}${HEAD1}:${c2}${HEAD1}`); setH(`${c0}${HEAD1}`, label);
          SUBS.forEach((s, si) => setH(`${L(firstCagrIdx + gi * nSub + si)}${HEAD2}`, `${s} (%)`, NAVY2));
        });
        ws.getRow(HEAD1).height = 30; ws.getRow(HEAD2).height = 20;

        // body
        let rowIdx = HEAD2 + 1;
        this.sections.forEach(sec => {
          ws.mergeCells(`A${rowIdx}:${last}${rowIdx}`);
          Object.assign(ws.getCell(`A${rowIdx}`), {
            value: sec.title.toUpperCase(), border,
            alignment: { vertical: "middle", horizontal: "left" },
            font: { bold: true, size: 10, color: { argb: "FF0B1F3A" } }, fill: fill(GROUP),
          });
          ws.getRow(rowIdx).height = 18; rowIdx++;

          sec.rows.forEach(r => {
            const row = ws.getRow(rowIdx);
            const isTotal = !!r.isTotal;
            const vals = [r.kategori];
            YEARS.forEach(y => { SUBS.forEach(s => vals.push(((r.values || {})[s] || {})[y])); });
            CAGR_COLS.forEach(c => vals.push(c.value(r)));
            vals.forEach((val, ci) => {
              const cell = row.getCell(ci + 1);
              // any value column (% or CAGR) renders "—" when null/missing
              if (ci !== 0 && (val === null || val === undefined)) cell.value = "—";
              else if (typeof val === "number") cell.value = Math.round(val * 10) / 10;
              else cell.value = val;
              cell.border = border;
              cell.alignment = ci === 0 ? { vertical: "middle", horizontal: "left", indent: r.indent ? 3 : isTotal ? 0 : 1 } : { vertical: "middle", horizontal: "right" };
              cell.font = { size: 11, bold: ci === 0 && isTotal };
              if (ci >= 1 && typeof cell.value === "number") cell.numFmt = '0.0';
            });
            if (isTotal) for (let c = 1; c <= nCols; c++) { row.getCell(c).fill = fill(TEAL); row.getCell(c).font = { size: 11, bold: true, color: { argb: WHITE } }; }
            else for (let c = 1; c <= nCols; c++) row.getCell(c).fill = fill(SUB);
            rowIdx++;
          });
          rowIdx++;
        });

        const buf = await wb.xlsx.writeBuffer();
        const blob = new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url; a.download = `${this.exportFileName}.xlsx`;
        document.body.appendChild(a); a.click(); a.remove();
        URL.revokeObjectURL(url);
      } catch (err) {
        this.snackbar = { show: true, message: err.message || "Eksport Excel gagal.", color: "error", timeout: 4000 };
      }
      this.exporting = false;
    },

    /* ---- styled PDF export ---- */
    async exportPDF() {
      this.exportingPdf = true;
      try {
        await loadTheme();
        await loadScript("/js/jspdf.umd.min.js");
        await loadScript("/js/jspdf.plugin.autotable.min.js");
        const { jsPDF } = window.jspdf;
        const NAVY = rgb(T.tajukLaporan), HEAD = rgb(T.kepalaJadual), NAVY2 = rgb(dark(T.kepalaJadual)), TEAL = rgb(T.graf), GROUP = [232, 238, 243];

        const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
        const pageW = doc.internal.pageSize.getWidth();
        const pageH = doc.internal.pageSize.getHeight();

        // ── Watermark (faded HIES logo) — painted FIRST so the title and table
        //    render on top of it. jsPDF has no z-order: paint order is stacking
        //    order, so "behind" = drawn before. 0.14 keeps the blue/green visible.
        const wm = await loadImage(hiesWatermark, 0.14);
        const wmH = 110; // mm
        const wmW = wm.width * (wmH / wm.height);
        const drawWatermark = () =>
          doc.addImage(wm.dataUrl, "PNG", (pageW - wmW) / 2, (pageH - wmH) / 2, wmW, wmH);
        drawWatermark(); // page 1 — later pages via autoTable's willDrawPage hook

        // ── Logo: Jata Negara crest + config-driven title (services/exportHeader) ──
        await addJataHeaderPdf(doc, pageW);

        doc.setFont("times", "bold"); doc.setFontSize(12); doc.setTextColor(NAVY[0], NAVY[1], NAVY[2]);
        doc.text(await surveyTitle(), pageW / 2, 35, { align: "center" });
        doc.setFontSize(10); doc.setTextColor(TEAL[0], TEAL[1], TEAL[2]);
        doc.text((this.amenity.exportTitle || this.amenity.cardTitle || "").toUpperCase(), pageW / 2, 41.5, { align: "center" });

        doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor(90);
        doc.text(
          `Pilihan: ${this.scopeName}     |     Pusingan: ${this.ddLabel}     |     Data: ${this.wajaranLabel}     |     Dijana: ${new Date().toLocaleString("en-MY")}`,
          14, 48
        );

        const YEARS = this.years, CAGR_PAIRS = this.cagrPairs;
        const CAGR_COLS = this.cagrExportCols, nCols = this.colCount;
        const SUBS = this.subCategories;
        const cagrBanners = !this.showCagr ? []
          : CAGR_PAIRS.length
            ? CAGR_PAIRS.map(p => `CAGR ${p.from}-${p.to} (%)`)
            : ["CAGR (%)"];
        const head = [
          [
            { content: "KATEGORI", rowSpan: 2 },
            ...YEARS.map(y => ({ content: String(y), colSpan: SUBS.length })),
            ...cagrBanners.map(label => ({ content: label, colSpan: SUBS.length })),
          ],
          [
            ...YEARS.flatMap(() => SUBS.map(s => `${s} (%)`)),
            ...cagrBanners.flatMap(() => SUBS.map(s => `${s} (%)`)),
          ],
        ];

        const kinds = [];
        const body = [];
        this.sections.forEach(sec => {
          kinds.push("group"); body.push([{ content: sec.title.toUpperCase(), colSpan: nCols }]);
          sec.rows.forEach(r => {
            kinds.push(r.isTotal ? "total" : r.indent ? "subindent" : "sub");
            body.push([
              r.kategori,
              ...YEARS.flatMap(y => SUBS.map(s => this.pct(((r.values || {})[s] || {})[y]))),
              ...CAGR_COLS.map(c => { const v = c.value(r); return (v === null || v === undefined) ? "—" : this.pf(v); }),
            ]);
          });
        });

        doc.autoTable({
          head, body, startY: 52,
          // pages the table adds get their watermark painted before their content
          // too (page 1 already has it — drawn above, before the header block)
          willDrawPage: d => { if (d.pageNumber > 1) drawWatermark(); },
          // fillColor:false = TRANSPARENT body cells, so the watermark painted
          // beneath the table shows through (the default theme paints every cell
          // white, which was hiding it). Meaningful fills (totals, group rows)
          // are still applied opaquely in didParseCell.
          theme: "plain",
          styles: { font: "helvetica", fontSize: 6.8, cellPadding: 1.3, halign: "right", lineColor: [226, 232, 240], lineWidth: 0.1, valign: "middle", fillColor: false },
          headStyles: { fillColor: HEAD, textColor: 255, halign: "center", fontSize: 6.5, valign: "middle" },
          columnStyles: { 0: { halign: "left", fontStyle: "bold" } },
          didParseCell: d => {
            // columnStyles outranks headStyles in autoTable, so column 0's header would
            // inherit its body halign:left — re-centre every header here instead.
            if (d.section === "head") d.cell.styles.halign = "center";
            if (d.section === "head" && d.row.index === 1) d.cell.styles.fillColor = NAVY2;
            if (d.section === "body") {
              const kind = kinds[d.row.index];
              if (kind === "group") { d.cell.styles.fillColor = GROUP; d.cell.styles.textColor = [11, 31, 58]; d.cell.styles.fontStyle = "bold"; d.cell.styles.halign = "left"; }
              else if (kind === "total") { d.cell.styles.fillColor = TEAL; d.cell.styles.textColor = 255; d.cell.styles.fontStyle = "bold"; }
              else if (kind === "sub" || kind === "subindent") {
                // no fill — transparent like the plain rows, so the watermark
                // shows through the amenity sub-category breakdowns too
                if (d.column.index === 0) {
                  d.cell.styles.fontStyle = "normal";
                  if (kind === "subindent") d.cell.styles.cellPadding = { left: 5, top: 1.3, right: 1.3, bottom: 1.3 };
                }
              }
            }
          },
        });

        // page numbers (e.g. "1/10") bottom-right on every page — the watermark
        // is painted per page BEFORE the content (see drawWatermark above)
        const pageCount = doc.internal.getNumberOfPages();
        doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor(120);
        for (let i = 1; i <= pageCount; i++) { doc.setPage(i); doc.text(`${i}/${pageCount}`, pageW - 14, pageH - 6, { align: "right" }); }

        doc.save(`${this.exportFileName}.pdf`);
      } catch (err) {
        this.snackbar = { show: true, message: err.message || "Eksport PDF gagal.", color: "error", timeout: 4000 };
      }
      this.exportingPdf = false;
    },
  },
};
</script>

<style scoped>
/* ---------- Bar penapis ----------
   Warna daripada palet yang dikongsi `paparanutama`, sidebar (MenuHeader) dan
   <PageHeader>: teal-700 #037769, wash #eef8f6, hair #dbeeeb. */
.filter-bar {
  background: #f7fcfb;
  border-top: 1px solid #dbeeeb;
  border-bottom: 1px solid #dbeeeb;
}

/* Label penapis — sama gaya dengan `.nav-eyebrow` dalam sidebar. */
.fld__label {
  font-size: var(--fs-3xs);
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #7aa8a2;
  line-height: 1.4;
  margin-bottom: 5px;
  white-space: nowrap;
}

/* Medan outlined: birai teal lembut, menyerlah teal-700 bila fokus. */
.filter-bar ::v-deep .v-input fieldset {
  border-color: #cfeae7;
}
.filter-bar ::v-deep .v-input--is-focused fieldset {
  border-color: #037769 !important;
  border-width: 1px;
}
.filter-bar ::v-deep .v-select__selection--comma {
  color: #21403c;
}
.filter-bar ::v-deep .v-input__append-inner .v-icon {
  color: #7aa8a2;
}

/* Butang "Tetapkan Semula" — dulu kelabu neutral; kini senada teal. */
.reset-btn.v-btn--outlined {
  border-color: #cfeae7;
  color: #037769;
  letter-spacing: normal;
}
.reset-btn.v-btn--outlined:hover {
  background: #eef8f6;
  border-color: #037769;
}

/* Compact Pusingan range select — one dropdown, "01 - 01" … "01 - 12" */
.pusingan-range .pusingan-sel {
  width: 116px;
  flex: 0 0 116px;
}
.pusingan-range ::v-deep .v-select__selections {
  flex-wrap: nowrap;
}
.pusingan-range ::v-deep .v-select__selection {
  overflow: visible;
  white-space: nowrap;
}
.pusingan-range ::v-deep .v-input__slot {
  padding: 0 8px !important;
}
.pusingan-range ::v-deep .v-input__append-inner {
  margin-left: 0;
}

.kemudahan-asas {
  padding: 16px;
  margin-left: -12px;
  margin-right: -12px;
}
/* Toggle Wajaran / Tanpa Wajaran: birai sepadan dengan medan outlined di
   sebelahnya; pilihan aktif = teal pejal (dulu biru `primary` Vuetify). */
.data-toggle {
  border: 1px solid #cfeae7;
  border-radius: 4px;
  overflow: hidden;
  background: #ffffff;
}
.data-toggle ::v-deep .v-btn {
  border: none !important;
  letter-spacing: normal;
  color: #4a8a84;
  background: transparent;
}
.data-toggle ::v-deep .v-btn.v-btn--active {
  background: #037769 !important;
  color: #ffffff !important;
}
/* Vuetify meletakkan lapisan legap pada butang aktif — ia mengaburkan teal. */
.data-toggle ::v-deep .v-btn.v-btn--active .v-btn__overlay,
.data-toggle ::v-deep .v-btn.v-btn--active::before {
  opacity: 0 !important;
}

/* charts above the table */
/* trend chart height follows the viewport (min 240px, max 420px) */
.trend-chart-box { position: relative; height: clamp(240px, 36vh, 420px); }
/* Kawalan di kepala kad graf (Tahun | Kategori | Susunan | Muat turun) memakai
   birai teal yang sama seperti bar penapis di atasnya — dulu kelabu neutral. */
.year-toggle { border: 1px solid #cfeae7; border-radius: 4px; overflow: hidden; }
.year-toggle ::v-deep .v-btn { border: none !important; letter-spacing: normal; color: #5d8f8a; }
.year-toggle ::v-deep .v-btn--active { background: #e6f6f5 !important; color: var(--warna-graf-gelap, #0B827F) !important; }

/* Kategori + Susunan toggles in the composition-chart header — active option tinted teal */
.sort-toggle { border: 1px solid #cfeae7; border-radius: 4px; overflow: hidden; }
.sort-toggle ::v-deep .v-btn { border: none !important; letter-spacing: normal; color: #5d8f8a; }
.sort-toggle ::v-deep .v-btn--active { background: #e6f6f5 !important; color: var(--warna-graf-gelap, #0B827F) !important; }
.sort-toggle ::v-deep .v-btn--active .v-icon { color: var(--warna-graf-gelap, #0B827F) !important; }

/* Butang muat turun graf — dulu butang ikon bulat tanpa birai, terapung di
   sebelah toggle berbirai. Butang ikon saiz lalai = 36px, sama tinggi
   dengan butang toggle saiz lalai. Jangan tetapkan tinggi. */
.dl-btn.v-btn--icon {
  border: 1px solid #cfeae7;
  border-radius: 4px;
}
/* Ikon dikecilkan daripada 24px lalai: butang ini berdiri di sebelah toggle
   berteks, jadi ikon setinggi teks (18px) membuatnya membaca sebagai kawalan
   yang sama beratnya, bukan butang yang lebih besar. */
.dl-btn ::v-deep .v-icon {
  color: #037769;
  font-size: var(--fs-lg);
  height: var(--fs-lg);
  width: var(--fs-lg);
}
.dl-btn:hover { background: #e6f6f5; border-color: #037769; }
/* Vuetify 2 melukis lapisan kelabu melalui `::before` (BUKAN `.v-btn__overlay`
   — itu Vuetify 3 dan tiada di sini). Tanpa ini, tuding teal jadi kelabu. */
.dl-btn ::v-deep::before { opacity: 0 !important; }

::v-deep .ks-table > .v-data-table__wrapper { overflow-x: auto; }
::v-deep .ks-table table { border-collapse: separate; border-spacing: 0; width: 100%; font-size: var(--fs-sm); white-space: nowrap; min-width: 1000px; }
::v-deep .ks-table thead th {
  background: var(--warna-kepala-jadual, #1B7E91); color: #fff !important; font-weight: 600; padding: 7px 10px;
  /* !important: Vuetify's `.v-application--is-ltr .v-data-table > .v-data-table__wrapper
     > table > thead > tr > th` sets text-align:left at a far higher specificity */
  text-align: center !important; border: 1px solid #2a8ea1; vertical-align: middle;
  font-size: var(--fs-sm) !important; line-height: 1.3; position: sticky; top: 0; z-index: 4;
}
::v-deep .ks-table thead th.strata-sub,
/* Satu takuk LEBIH KECIL daripada baris kepala di atasnya (--fs-xs): itulah
   yang menandakan baris ini sebagai sub-kepala. Jika kedua-duanya sama saiz,
   dua baris kepala itu terbaca sebagai satu blok. */
::v-deep .ks-table thead th.cagr-sub { background: var(--warna-kepala-jadual-2, #15606F); font-size: var(--fs-xs) !important; }
::v-deep .ks-table thead th.cat { left: 0; z-index: 6; }
::v-deep .ks-table tbody td {
  padding: 9px 10px; border: 1px solid #E2E8F0; text-align: right; color: #0B1F3A; font-size: var(--fs-sm);
}
::v-deep .ks-table tbody td.cat {
  text-align: left; font-weight: 600; position: sticky; left: 0; background: #fff; z-index: 2;
}
::v-deep .ks-table tbody td.cagr-empty { text-align: center; color: #94A3B8; }
::v-deep .ks-table tbody tr:hover td { background: #EFF7F7 !important; }
::v-deep .ks-table tbody tr.total td { background: var(--warna-graf, #0EA5A4) !important; color: #fff; font-weight: 700; border-color: var(--warna-graf-gelap, #0B827F); }
::v-deep .ks-table tbody tr.total td.cat { background: var(--warna-graf, #0EA5A4) !important; color: #fff; }
::v-deep .ks-table tbody tr.section td.cat {
  background: #E8EEF3 !important; color: #0B1F3A; font-weight: 700; text-transform: uppercase;
  letter-spacing: .4px; font-size: var(--fs-xs); text-align: left; position: static;
}
::v-deep .ks-table tbody tr.sub td { background: #F4F8FA !important; }
::v-deep .ks-table tbody tr.sub td.cat { background: #F4F8FA !important; padding-left: 24px; font-weight: 600; }
/* Bumiputera ethnic sub-groups (Sabah/Sarawak) inset one more level */
::v-deep .ks-table tbody tr.sub td.cat.indent { padding-left: 44px; font-weight: 400; }
::v-deep .ks-table tbody tr.spacer td { background: #475569 !important; padding: 0; height: 6px; border: none; }
</style>
